export var TextfieldSizes;
(function (TextfieldSizes) {
    TextfieldSizes["sm"] = "sm";
    TextfieldSizes["md"] = "md";
    TextfieldSizes["lg"] = "lg";
})(TextfieldSizes || (TextfieldSizes = {}));
export var TextfieldVariants;
(function (TextfieldVariants) {
    TextfieldVariants["outline"] = "outline";
    TextfieldVariants["standard"] = "standard";
    TextfieldVariants["fill"] = "fill";
})(TextfieldVariants || (TextfieldVariants = {}));
